import React, { memo, useEffect, useRef } from 'react';
import ResultRecommendations from '@/components/features/result/ResultRecommendations/ResultRecommendations';
import ResultHeader from '@/components/features/result/ResultHeader/ResultHeader';
import BasicContainer from '@/components/templates/containers/BasicContainer/BasicContainer';
import { InnerContainer } from '@/components/atoms/Containers';
import { useDispatch, useSelector } from 'react-redux';
import { selectBlocks, selectResultError, selectResultIsFetching } from '@/store/selectors/resultSelectors';
import ConditionalBlock from '@/components/features/result/ConditionalBlock/ConditionalBlock';
import { GlobalBackgroundStyle, ResultDescriptionContainer, ResultMainWrap, Wrap } from './styles';
import SEO from '@/components/features/SEO/SEO';
import ResultDescription from '@/components/features/result/ResultDescription/ResultDescription';
import ResultSidebar from '@/components/features/result/ResultSidebar/ResultSidebar';
import { selectAttemptKey } from '@/store/selectors/selectAttemptKey';
import { dispatch } from 'd3';
import { fetchResult } from '@/store/reducers/resultSlice';
import { AppDispatch } from '@/store/store';
import { extractTestId, setIsTesting } from '@/store/reducers/testingSlice';
import Loader from '@/components/atoms/UI/Loader/Loader';
import { useParams } from 'react-router-dom';
import ErrorWithReload from '@/components/molecules/ErrorWithReload/ErrorWithReload';


interface ResultProps {
	fromAttempt?: boolean
	clickedBtn?: string
}

const Result: React.FC<ResultProps> = ({fromAttempt, clickedBtn}) => {
	const dispatch: AppDispatch = useDispatch();
	const triggerRef = useRef<HTMLDivElement>(null);
	const blocks = useSelector(selectBlocks);
	const recommendTests = blocks.recommendTests;
	const isFetching = useSelector(selectResultIsFetching);
	const error = useSelector(selectResultError);

	const alreadyLoadedAttemptKey = useSelector(selectAttemptKey);


	useEffect(() => {
		const exitButton = document.querySelector('.ts__exit-btn') as HTMLElement;
		if (exitButton) {
			exitButton.style.display = 'none';
		}

		return () => {
			if (exitButton) {
				exitButton.style.display = '';
			}
		};
	}, []);

	useEffect(() => {
		document.body.style.background = 'none';

		return () => {
			document.body.style.background = '';
		};
	}, []);

	useEffect(() => {
		if (!alreadyLoadedAttemptKey && !error) {
			const testId = dispatch(extractTestId('test-process'));

			if (testId) {
				dispatch(fetchResult(testId));
			}
		}
	}, [alreadyLoadedAttemptKey, error]);

	if (error) {
		return <ErrorWithReload error={error} />;
	}

	return (
		<>
			<SEO />
			<GlobalBackgroundStyle />
			{isFetching ? <Loader dark /> :
				<BasicContainer>
					<Wrap>
						<ResultHeader fromAttempt={fromAttempt} triggerRef={triggerRef} clickedBtn={clickedBtn}/>

						<span ref={triggerRef}></span>

						<ResultMainWrap>
							<InnerContainer>
								<ResultDescriptionContainer>
									<ResultDescription/>
									<ResultSidebar />
								</ResultDescriptionContainer>
							</InnerContainer>
						</ResultMainWrap>

						<ConditionalBlock block={recommendTests}>
							<ResultRecommendations/>
						</ConditionalBlock>
					</Wrap>
				</BasicContainer>
			}

		</>

	)
}

export default memo(Result);
